import useBreakerGallery from 'hooks/useBreakerGallery';
import useBreakerModal from 'hooks/useBreakerModal';
import React from 'react';
import BreakerModal from './BreakerModal';
import { Collection } from './Collection';
import { FiltersView } from './FiltersView';

export const BreakerGallery = () => {
  const {
    isLoading,
    breakers,
    activeFilters,
    attributeMap,
    setFilter,
    removeFilter,
    clearFilters,
    loadMore,
    count,
    getBreakerById,
    onSearch,
    search,
  } = useBreakerGallery();

  const { setId, clearId, selectedBreakerId } = useBreakerModal();

  if (!breakers || isLoading) {
    return null;
  }

  const selectedBreaker = getBreakerById(selectedBreakerId);

  return (
    <div className="row d-flex">
      <FiltersView
        search={search}
        onSearch={onSearch}
        activeFilters={activeFilters}
        removeFilter={removeFilter}
        setFilter={setFilter}
        attributeMap={attributeMap}
      />

      <Collection
        collectionName="breakers"
        setId={setId}
        items={breakers}
        activeFilters={activeFilters}
        count={count}
        removeFilter={removeFilter}
        clearFilters={clearFilters}
        loadMore={loadMore}
      />
      {selectedBreaker && <BreakerModal breaker={selectedBreaker} onClose={clearId} />}
    </div>
  );
};
